import { render, staticRenderFns } from "./TransferReason.vue?vue&type=template&id=0470a646&"
import script from "./TransferReason.vue?vue&type=script&lang=js&"
export * from "./TransferReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports